import React from 'react'
import template from 'lodash/template'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { selectFundraisingPage } from '../../../store/fundraisingPage'
import { selectTeam } from '../../../store/team'

export const withInjectParams = ComponentToWrap => {
  const Component = ({
    router: {
      location: {
        query: {
          amount,
          name,
          first_name,
          answer_1,
          answer_2,
          answer_3
        } = {}
      } = {}
    } = {},
    ...props
  }) => {
    const injectParams = (str) => template(str)({
      amount,
      name,
      first_name,
      answer_1,
      answer_2,
      answer_3,
      ...props.fundraisingPage,
      ...props.team,
      ...props.injectData
    })

    return (
      <ComponentToWrap
        injectParams={injectParams}
        {...props}
      />
    )
  }

  const mapStateToProps = (state, props) => ({
    fundraisingPage: selectFundraisingPage(state, props),
    team: selectTeam(state, props)
  })

  return compose(
    connect(mapStateToProps),
    withRouter
  )(Component)
}

const InjectParams = withInjectParams(
  ({
    children,
    injectParams
  }) => (
    <span>
      {injectParams(children)}
    </span>
  )
)

export default InjectParams
